module.exports = __webpack_public_path__ + "static/media/chat.6081e92b.svg";